export const convertApiTimeToString = (time, lang) => {
    const locale = lang === "tr" ? "tr-TR" : "ru-RU";
    const rawDate = new Date(time);
    if(isNaN(rawDate))
    {
        switch(locale) {
            case "ru-RU":
                return "Время не указано";
            case "tr-TR":
                return "Zaman belirtilmedi";
            default:
                return "Time not specified";
        }
    }

    const date = new Date(Date.UTC(rawDate.getFullYear(), rawDate.getMonth(), rawDate.getDate(), rawDate.getHours(), rawDate.getMinutes(), rawDate.getSeconds()));
    const year = date.getFullYear();


    let month;
    if(locale === "ru-RU")
        month = date.toLocaleDateString(locale, { month: "short" });
    else if(locale === "tr-TR")
        month = date.toLocaleDateString(locale, { month: "long" });

    //Capitalize first letter and remove dot at the end
    month = month.charAt(0).toUpperCase() + month.slice(1, -1);
    month = month === "Ма" ? "Мая" : month;
    
    const day = date.getDate();
    const hours = date.getHours();

    let minutes = date.getMinutes();
    //Add leading zero if minutes < 10
    let minutesStr = (minutes < 10 ? "0" : "") + minutes;

    return `${day} ${month} ${year} ${hours}:${minutesStr}`;
};

export const convertApiTimeToStringWithoutTime = (time,lang) => {
    const locale = lang === "tr" ? "tr-TR" : "ru-RU";
    const rawDate = new Date(time);
    const date = new Date(Date.UTC(rawDate.getFullYear(), rawDate.getMonth(), rawDate.getDate(), rawDate.getHours(), rawDate.getMinutes(), rawDate.getSeconds()));
    const year = date.getFullYear();

    let month; 
    if(locale === "ru-RU")
        month = date.toLocaleDateString(locale, { month: "short" });
    else if(locale === "tr-TR")
        month = date.toLocaleDateString(locale, { month: "long" });

    //Capitalize first letter and remove dot at the end
    month = month.charAt(0).toUpperCase() + month.slice(1, -1);
    month = month === "Ма" ? "Мая" : month;
    
    const day = date.getDate();
    return `${day} ${month} ${year} `;
};

export const getUnixTime = (time) => {
    return new Date(time).getTime();
};
